export const userStatsGeneral = [
  { name: "Nome do usuário", value: "name", filter: true },
  { name: "Nome do curso", value: "courseName", filter: true },
  { name: "Média", value: "average", filter: false },
  { name: "Reprov. em quiz", value: "quizFailed", filter: false },
  { name: "Status", value: "status", filter: false },
];

export const userActions = [
  {
    title: "Ver aluno",
    icon: null,
    type: "goTo",
    style: "btn-outline",
    tooltip: "Ver aluno",
  },
];


